
import { useState } from "react";

export type RollerState = "welcome" | "rolling" | "result";
export type PromptStage = "none" | "perception" | "intention" | "nextStep" | "twist" | "lensFocus";

export function useRollerState() {
  const [rollerState, setRollerState] = useState<RollerState>("welcome");
  const [promptStage, setPromptStage] = useState<PromptStage>("none");
  
  const resetState = () => {
    setRollerState("welcome");
    setPromptStage("none");
  };
  
  return {
    rollerState,
    setRollerState,
    promptStage,
    setPromptStage,
    resetState
  };
}
